/* Drop "Kann nicht aus meiner Haut": Wendepunkt als Scroll-Clip.
   - Nur mit Bewegung und ohne Datensparmodus: Klasse is-scrub (Abschnitt ca. 150vh angeheftet).
   - Bilder laden erst, wenn der Abschnitt näher als ca. 1,5 Bildschirmhöhen ist; Reihenfolge grob nach fein
     (erstes, letztes, Mitte, ...), gezeichnet wird immer das nächstgelegene schon geladene Bild.
   - Zeichnen nur in requestAnimationFrame und nur, wenn sich Bild oder Größe geändert haben.
   - Strich 40 bis 70 %, "Will" 70 bis 85 % des Fortschritts (CSS-Variablen --k-strike, --k-will). */
(function () {
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function pad(i) { return ('00' + i).slice(-3); }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var c = navigator.connection;
    var save = c && (c.saveData || /2g/.test(c.effectiveType || ''));
    var n = parseInt(root.dataset.count, 10) || 60;
    if (reduce.matches || save || !root.dataset.baseD || !window.requestAnimationFrame || !('IntersectionObserver' in window)) return;

    var track = root.querySelector('.knamh-scrub__track');
    var canvas = root.querySelector('.knamh-scrub__canvas');
    var ctx = canvas.getContext('2d', { alpha: false });
    if (!ctx) return;
    root.classList.add('is-scrub');

    var mobile = window.matchMedia('(max-width: 749px)');
    var sets = {};          // 'd' | 'm' -> Array<Image|null>
    var cur = -1, curSet = '', cw = 0, ch = 0, ticking = false, near = false, lastP = -1;

    function setKey() { return mobile.matches && root.dataset.baseM ? 'm' : 'd'; }
    function order() {
      // 0, n-1, dann halbieren: grob nach fein
      var out = [0, n - 1], seen = {}, step = n - 1;
      seen[0] = seen[n - 1] = 1;
      while (step > 1) {
        step = Math.ceil(step / 2);
        for (var i = step; i < n; i += step) if (!seen[i]) { seen[i] = 1; out.push(i); }
        if (step === 1) break;
      }
      for (var j = 0; j < n; j++) if (!seen[j]) out.push(j);
      return out;
    }
    function load(key) {
      if (sets[key]) return;
      var arr = sets[key] = new Array(n);
      var base = key === 'm' ? root.dataset.baseM : root.dataset.baseD;
      var ext = root.dataset.ext || '.webp';
      var q = order(), active = 0, k = 0;
      function next() {
        while (active < 4 && k < q.length) {
          (function (idx) {
            var img = new Image();
            img.decoding = 'async';
            active++;
            img.onload = function () {
              active--;
              var done = function () { arr[idx] = img; if (key === curSet) { cur = -1; schedule(); } next(); };
              if (img.decode) img.decode().then(done, done); else done();
            };
            img.onerror = function () { active--; next(); };
            img.src = base + pad(idx) + ext;
          })(q[k++]);
        }
      }
      next();
    }
    function nearest(arr, i) {
      if (arr[i]) return i;
      for (var d = 1; d < n; d++) {
        if (i - d >= 0 && arr[i - d]) return i - d;
        if (i + d < n && arr[i + d]) return i + d;
      }
      return -1;
    }
    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = Math.round(canvas.clientWidth * dpr), h = Math.round(canvas.clientHeight * dpr);
      if (w !== cw || h !== ch) { cw = canvas.width = w; ch = canvas.height = h; cur = -1; }
    }
    function progress() {
      var r = track.getBoundingClientRect();
      var span = r.height - window.innerHeight;
      return span > 0 ? clamp(-r.top / span) : 0;
    }
    function draw() {
      ticking = false;
      var p = progress();
      if (p !== lastP) {
        lastP = p;
        root.style.setProperty('--k-strike', clamp((p - 0.4) / 0.3).toFixed(3));
        root.style.setProperty('--k-will', clamp((p - 0.7) / 0.15).toFixed(3));
      }
      var key = setKey();
      if (key !== curSet) { curSet = key; cur = -1; load(key); }
      size();
      var arr = sets[key];
      var want = Math.round(p * (n - 1));
      var i = nearest(arr, want);
      if (i < 0 || (i === cur)) return;
      cur = i;
      var img = arr[i];
      var s = Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
      var dw = img.naturalWidth * s, dh = img.naturalHeight * s;
      ctx.drawImage(img, (cw - dw) / 2, (ch - dh) * 0.35, dw, dh);
      root.classList.add('is-drawn');
    }
    function schedule() {
      if (!near || ticking) return;
      ticking = true;
      requestAnimationFrame(draw);
    }

    var io = new IntersectionObserver(function (es) {
      near = es[0].isIntersecting;
      if (near) { load(setKey()); schedule(); }
    }, { rootMargin: '150% 0px 150% 0px' });
    io.observe(root);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () { cur = -1; schedule(); }, { passive: true });
    var off = function () {
      root.classList.remove('is-scrub', 'is-drawn');
      near = false; io.disconnect();
      root.style.removeProperty('--k-strike'); root.style.removeProperty('--k-will');
    };
    if (reduce.addEventListener) reduce.addEventListener('change', function (e) { if (e.matches) off(); });
  }

  function run() { document.querySelectorAll('[data-knamh-scrub]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
